(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-sign-up"] && !Shopify.designMode) return;
  try {
    const groupBlock = document.querySelector('#sign-up')?.closest('[data-testid="group-block"]');
  if (groupBlock) {
   groupBlock.style.overflow = 'visible';
  }
  const selectEl = document.querySelector('.sign-up__select');
  const purposeEls = document.querySelectorAll('.sign-up__purpose');
  const tagsEl = document.querySelector('.sign-up__tags');
  const workplaceInput = document.querySelector('#workplace-input');
  const workplaceContainer = document.querySelector('#workplace-input-container');

  if (selectEl && purposeEls.length && tagsEl) {
    const initialTagValue = tagsEl.value;
    let data = { country: undefined, purpose: undefined, workplace: undefined };

    const updateTags = () => {
      tagsEl.value = initialTagValue;
      tagsEl.value += data.country ? `,Market: ${data.country}` : '';
      tagsEl.value += data.purpose ? `,Purpose: ${data.purpose}` : '';
      tagsEl.value += data.workplace ? `,Workplace: ${data.workplace}` : '';
    };

    const toggleWorkplace = (show) => {
      if (show) {
        workplaceInput.value = '';
        workplaceContainer.style.display = 'unset';
      } else {
        workplaceContainer.style.display = 'none';
      }
    };

    selectEl.addEventListener('change', (e) => {
      data.country = e.target.value;
      updateTags();
    });

    workplaceInput.addEventListener('input', (e) => {
      data.workplace = e.target.value;
      updateTags();
    });

    purposeEls.forEach((el) => {
      el.addEventListener('change', (e) => {
        data.purpose = e.target.value;
        updateTags();
        toggleWorkplace(e.target.value === 'Professional');
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
